var path = '/apex-main-app/shared/errors/app-outdated.component.html';
var html = "<div class=error-page> <div class=jumbotron> <h2 class=h1>Update Required</h2> <p> Apex needs to reload in order to install the updated web app. </p> </div> </div> ";
window.angular.module('apex.core.templateCache').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;